// The legacy Backstage scaffolder (/create), a React 18 remote mounted in a LegacyReactIsland.
export default {
  remote: 'simplify_hub_scaffolder_mfe',
  name: 'scaffolder',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    localhost: 'http://localhost:4380/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1100769639/simplify-scaffolder/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1100769639/simplify-scaffolder/v1/mf2/mf-manifest.json',
    'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-scaffolder/v1/mf2/mf-manifest.json',
  },
};
